import './style.sass';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
const Testing = () => {
    return (
        <div className="ck10-testing">
            <FullWrapper isMargin={false}>
                <div className="ck10-testingInner">
                    <div className="ck10-testingLeft">
                        <div className="ck10-testingTitle">
                            Тестирование&nbsp;новых инструментов
                        </div>
                        <div className="ck10-testingParagraf">
                            Наша команда с&nbsp;проектом СК10 стала одной из&nbsp;первых, кто
                            тестировал бета-версию нового инструмента Яндекса&nbsp;&mdash; запуск
                            рекламы в&nbsp;Telegram. Получили хороший результат на&nbsp;узких
                            геонастройках: более 100 качественных лидов, процент качества составил
                            60%, CPL стал ниже на&nbsp;65%, относительно других РК.
                        </div>
                        <div className="ck10-testingParagraf">
                            На&nbsp;данный момент эта кампания дает самые дешевые качественные лиды
                            среди всех запусков. Подробнее о&nbsp;результатах тестирования данного
                            рекламного инструмента рассказали{' '}
                            <a
                                className="ck10-testingLink"
                                href="https://vc.ru/marketing/931575-novyi-instrument-prodvizheniya-v-telegram-kanalah-cherez-yandeks-direkt-rezultaty-pervyh-testov "
                                target="_blank"
                                rel="noreferrer"
                            >
                                в&nbsp;статье
                            </a>
                            .
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Testing;
